import HomeHeader from "../HomePage/components/HomeHeader";
// import "../Homepage/home.css";
import CallIcon from "@mui/icons-material/Call";
import "./styles.css";
import { ChangeEvent, useState } from "react";
import { CircularProgress, Dialog } from "@mui/material";
import { useSnackbar } from "../../context/SnackbarContext";
import { sendOnboardOtp, submitOnboardForm } from "../../api/onboard";
import { useNavigate } from "react-router-dom";
import { CountryData } from "react-phone-input-2";
import OnboardMobileInput from "../../Components/MobileInput/OnboardMobileInput";

function isWorkEmail(email: string): boolean {
  // Regular expression to match common email providers
  const commonProvidersRegex =
    /@(gmail\.com|yahoo\.com|hotmail\.com|outlook\.com)$/i;
  return !commonProvidersRegex.test(email);
}

const OnboardingPage = () => {
  const handleGuide = () => {
    window.open(
      "https://tascoutsourcing.com/campaigns/emiratization-guidebook/",
      "_blank"
    );
  };

  const verifyOtp = async (passedOtp: string) => {
    setLoading(true);

    if (!!otp && !!form.email.length) {
      const resp = await submitOnboardForm({
        email: form.email,
        verificationCode: passedOtp,
      });

      if (resp?.data?.data?.id) {
        setSubmitted(true);
        navigate("/dashboard");
        localStorage.setItem("userId", resp.data.data.id);
      } else {
        showSnackbar(resp?.data?.responseInfo?.description, "error");
      }
    } else {
      showSnackbar("Please enter the otp", "error");
    }

    setLoading(false);
  };

  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState("");

  const handleOtp = (e: ChangeEvent<HTMLInputElement>) => {
    setOtp(e.target.value);
    if (e.target.value.length === 4) {
      verifyOtp(e.target.value);
    }
  };

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    companyName: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setForm((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  function isValidPassword(password: string): boolean {
    // Check if the password meets the minimum length requirement
    if (password.length < 8) {
      return false;
    }

    // Check if the password contains at least one uppercase letter
    if (!/[A-Z]/.test(password)) {
      return false;
    }

    // Check if the password contains at least one lowercase letter
    if (!/[a-z]/.test(password)) {
      return false;
    }

    // If all criteria pass, return true
    return true;
  }

  const navigate = useNavigate();

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { showSnackbar } = useSnackbar();

  const handleSendOtp = async () => {
    setLoading(true);

    if (
      !!form.firstName.length &&
      !!form.email.length &&
      !!form.companyName.length &&
      !!form.password.length &&
      !!form.phoneNumber.length &&
      !!countryCode.length &&
      !!form.confirmPassword.length
    ) {
      if (!isWorkEmail(form.email)) {
        showSnackbar("Please enter your work email Id", "error");
        setLoading(false);

        return;
      }
      if (!isValidPassword(form.password)) {
        showSnackbar(
          "Please enter a password that is at least 8 characters long and contains at least one uppercase letter and one lowercase letter.",
          "error"
        );
        setLoading(false);

        return;
      }
      if (form.password === form.confirmPassword) {
        const resp = await sendOnboardOtp({
          email: form.email,
          companyName: form.companyName,
          countryCode: countryCode,
          mobileNumber: form.phoneNumber.replace(countryCode, ""),
          password: form.password,
          firstName: form.firstName,
        });

        if (!!resp) {
          setShowOtp(true);
        } else {
          showSnackbar("Failed to send OTP", "error");
        }
      } else {
        showSnackbar("Passwords do not match", "error");
      }
    } else {
      showSnackbar("Please enter all the details", "error");
    }

    setLoading(false);
  };

  const [countryCode, setCountryCode] = useState("+971");

  const handlePhoneChange = (value: string, country: CountryData) => {
    setCountryCode(country.dialCode);
    setForm((prevState) => ({
      ...prevState,
      ["phoneNumber"]: value,
    }));
  };

  const handleVerify = () => {
    verifyOtp(otp);
  };

  return (
    <div className="main_home_container">
      <HomeHeader />
      <div className="home_section_1">
        {submitted ? (
          <div className="max_home_width">
            <div className="home_section_1_wrapper">
              <div className="home_section_1_content">
                <div>
                  <h1 className="main_content_text max_text_width fs-48">
                    <span className="ft_text">Success!</span>
                    <span className="text-white">
                      {" "}
                      Your form has been submitted
                    </span>
                  </h1>
                  <h3 className="main_content_text max_text_width text-white">
                    You will receive an email from us shortly.
                  </h3>
                </div>
                <div className="display_center">
                  <div onClick={handleGuide} className="callButton">
                    <CallIcon />
                    {/* <img src={arrowImg} alt="logo" className="home_arrow_btn" /> */}
                    <div>Contact Us</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="max_home_width">
            <div className="home_section_1_wrapper">
              <div className="home_section_1_content">
                <h1 className="main_content_text_left max_text_width fs-48">
                  <span className="ft_text">Claim Your 3-Month Free Pass!</span>
                  <span className="text-white">
                    {" "}
                    Access premium features now.
                  </span>
                </h1>
                <h1 className="main_content_text_left max_text_width text-white fs-18">
                  Post Unlimited Emirati Jobs For 3 Months!{" "}
                </h1>
                <div onClick={handleGuide} className="callButton">
                  {/* <img src={arrowImg} alt="logo" className="home_arrow_btn" /> */}
                  <div>Download Guide</div>
                </div>
              </div>

              {showOtp ? (
                <div className="home_form_container">
                  <div className="main_content_text_left max_text_width">
                    <span className="ft_text_2 fs-32">Verification</span>
                  </div>
                  <div className="home_form_line_wrapper">
                    <div className="ak_form_input_wrapper w-full">
                      <input
                        className="ak_form_input"
                        type="text"
                        placeholder="OTP Received in your email*"
                        onChange={handleOtp}
                        value={otp}
                      />
                    </div>
                  </div>
                  <div
                    onClick={handleVerify}
                    className="callButton form_submit_btn"
                  >
                    <div>Verify</div>
                  </div>
                </div>
              ) : (
                <div className="home_form_container">
                  <div className="main_content_text_left max_text_width">
                    <span className="ft_text_2 fs-32">
                      Fill in your details
                    </span>
                  </div>

                  <div className="home_form_line_wrapper">
                    <div className="ak_form_input_wrapper w-full">
                      <input
                        className="ak_form_input"
                        type="text"
                        placeholder="Name*"
                        onChange={handleChange}
                        name="firstName"
                        value={form.firstName}
                      />
                    </div>
                    <div className="ak_form_input_container w-full">
                      <OnboardMobileInput handleChange={handlePhoneChange} />
                    </div>
                  </div>
                  <div className="home_form_line_wrapper">
                    <div className="ak_form_input_wrapper">
                      <input
                        className="ak_form_input"
                        type="email"
                        placeholder="Work Email*"
                        onChange={handleChange}
                        name="email"
                        value={form.email}
                      />
                    </div>
                    <div className="ak_form_input_wrapper w-full">
                      <input
                        className="ak_form_input"
                        type="text"
                        placeholder="Company Name*"
                        onChange={handleChange}
                        name="companyName"
                        value={form.companyName}
                      />
                    </div>
                  </div>
                  <div className="home_form_line_wrapper">
                    <div className="ak_form_input_wrapper">
                      <input
                        className="ak_form_input"
                        type="password"
                        placeholder="Create Password*"
                        onChange={handleChange}
                        name="password"
                        value={form.password}
                      />
                    </div>
                    <div className="ak_form_input_wrapper">
                      <input
                        className="ak_form_input"
                        type="password"
                        placeholder="Confirm Password*"
                        onChange={handleChange}
                        name="confirmPassword"
                        value={form.confirmPassword}
                      />
                    </div>
                  </div>

                  <div
                    onClick={handleSendOtp}
                    className="callButton form_submit_btn"
                  >
                    <div>Submit</div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <Dialog open={loading}>
        <div className="submit_loader">
          <CircularProgress color="inherit" size={30} />
        </div>
      </Dialog>
    </div>
  );
};

export default OnboardingPage;
